class ReadingControls {
  constructor() {
    this.controls = document.querySelector("[data-reading-controls]");
    this.target = document.querySelector("[data-reading-scale-target]");

    if (!this.controls || !this.target) {
      return;
    }

    this.storageKey = "united3000ReadingScale";
    this.min = 80;
    this.max = 140;
    this.step = 5;
    this.defaultValue = 100;
    this.range = this.controls.querySelector("[data-reading-scale-range]");
    this.value = this.controls.querySelector("[data-reading-scale-value]");
    this.decrease = this.controls.querySelector("[data-reading-scale-decrease]");
    this.increase = this.controls.querySelector("[data-reading-scale-increase]");
    this.reset = this.controls.querySelector("[data-reading-scale-reset]");

    this.init();
  }

  init() {
    this.setScale(this.getSavedScale());

    this.range?.addEventListener("input", (event) => {
      this.setScale(Number(event.target.value), true);
    });

    this.decrease?.addEventListener("click", () => {
      this.setScale(this.getCurrentScale() - this.step, true);
    });

    this.increase?.addEventListener("click", () => {
      this.setScale(this.getCurrentScale() + this.step, true);
    });

    this.reset?.addEventListener("click", () => {
      this.setScale(this.defaultValue, true);
    });
  }

  getSavedScale() {
    const storedValue = window.localStorage.getItem(this.storageKey);

    if (storedValue === null) {
      return this.defaultValue;
    }

    const savedValue = Number(storedValue);

    if (!Number.isFinite(savedValue)) {
      return this.defaultValue;
    }

    return savedValue;
  }

  getCurrentScale() {
    return Number(this.range?.value) || this.defaultValue;
  }

  normalizeScale(value) {
    const normalizedValue = Math.round(value / this.step) * this.step;

    return Math.min(this.max, Math.max(this.min, normalizedValue));
  }

  setScale(value, shouldSave = false) {
    const scale = this.normalizeScale(value);
    const scaleRatio = scale / 100;

    document.documentElement.style.setProperty("--reading-scale", scaleRatio.toString());
    document.documentElement.dataset.readingScale = scale.toString();

    if (this.range) {
      this.range.value = scale.toString();
      const progress = ((scale - this.min) / (this.max - this.min)) * 100;
      this.range.style.setProperty("--reading-range-progress", `${progress}%`);
    }

    if (this.value) {
      this.value.textContent = `${scale}%`;
    }

    if (shouldSave) {
      window.localStorage.setItem(this.storageKey, scale.toString());
    }
  }
}

export default ReadingControls;
